import React, { useEffect, useState } from "react";
import { circlesApi } from "./circlesApi";
import { useBusy } from "./circlesShared";
import "../../assets/css/WebsiteLeads.css";
import "../../assets/css/Circles.css";
import "../../assets/css/PageHeading.css";

const TOGGLES = [
  ["recruitmentEnabled", "Agents can recruit other agents (Team)", "Leave off on Day 1; turn on with Level 2."],
  ["agentAutoApprove", "Approve new agents automatically", "Off: staff approve each agent and their business types."],
  ["maskCustomerMobile", "Hide customer numbers from agents until a sale is won", ""],
  ["firstAgentWins", "First agent keeps the customer", "Off: a newer link can take over while the enquiry is still New."],
];

export default function CirclesSettings() {
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState("");
  const { busy, error, setError, run } = useBusy();

  useEffect(() => {
    circlesApi
      .settings()
      .then((res) => setForm({ ...res.data, defaultLevelRates: (res.data.defaultLevelRates || []).join(", ") }))
      .catch((err) => setError(err.message));
  }, [setError]);

  if (!form) return <div className="p-3">{error ? <div className="wl-alert wl-alert--error">{error}</div> : "Loading…"}</div>;
  const set = (patch) => {
    setSaved("");
    setForm((f) => ({ ...f, ...patch }));
  };

  const save = () =>
    run(async () => {
      const body = {
        ...form,
        maxLevels: Number(form.maxLevels),
        defaultTdsPct: Number(form.defaultTdsPct),
        minPayoutAmount: Number(form.minPayoutAmount),
        defaultLevelRates: String(form.defaultLevelRates)
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
          .map(Number),
      };
      const res = await circlesApi.saveSettings(body);
      setForm({ ...res.data, defaultLevelRates: (res.data.defaultLevelRates || []).join(", ") });
      setSaved("Settings saved.");
    });

  return (
    <div className="p-2 p-md-3">
      <div className="co-page-head">
        <h2 className="co-page-head__title">Circles Settings</h2>
      </div>
      <form
        className="cx-settings"
        onSubmit={(e) => {
          e.preventDefault();
          save();
        }}
      >
        <div className="cx-card">
          <h3>Levels and default commission</h3>
          <div className="cx-row">
            <label className="wl-field">
              <span>Levels paid</span>
              <select value={form.maxLevels} onChange={(e) => set({ maxLevels: Number(e.target.value) })}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <option key={n} value={n}>
                    {n === 1 ? "Level 1 only" : `Levels 1 to ${n}`}
                  </option>
                ))}
              </select>
            </label>
            <label className="wl-field">
              <span>Default commission</span>
              <select value={form.defaultCommissionType} onChange={(e) => set({ defaultCommissionType: e.target.value })}>
                <option value="Percent">% of deal value</option>
                <option value="Fixed">Fixed ₹ per sale</option>
              </select>
            </label>
            <label className="wl-field">
              <span>Default rate{form.maxLevels > 1 ? "s (L1, L2…)" : ""}</span>
              <input value={form.defaultLevelRates} onChange={(e) => set({ defaultLevelRates: e.target.value })} />
            </label>
          </div>
          <p className="cx-hint">New projects start with these; each project can set its own.</p>
        </div>
        <div className="cx-card">
          <h3>Payouts</h3>
          <div className="cx-row">
            <label className="wl-field">
              <span>TDS %</span>
              <input type="number" min="0" max="30" step="0.5" value={form.defaultTdsPct} onChange={(e) => set({ defaultTdsPct: e.target.value })} />
            </label>
            <label className="wl-field">
              <span>Minimum payout (₹)</span>
              <input type="number" min="0" step="100" value={form.minPayoutAmount} onChange={(e) => set({ minPayoutAmount: e.target.value })} />
            </label>
          </div>
        </div>
        <div className="cx-card">
          <h3>Agents and customers</h3>
          <div className="d-flex flex-column gap-2">
            {TOGGLES.map(([key, label, hint]) => (
              <label key={key} className="cx-check align-items-start">
                <input type="checkbox" checked={!!form[key]} onChange={(e) => set({ [key]: e.target.checked })} />
                <span>
                  {label}
                  {hint ? <span className="cx-hint d-block">{hint}</span> : null}
                </span>
              </label>
            ))}
          </div>
        </div>
        {error ? <div className="wl-alert wl-alert--error">{error}</div> : null}
        {saved ? <div className="wl-alert wl-alert--success">{saved}</div> : null}
        <div>
          <button type="submit" className="wl-btn wl-btn--primary" disabled={busy}>
            Save settings
          </button>
        </div>
      </form>
    </div>
  );
}
